// extracted by mini-css-extract-plugin
module.exports = {"navigationWrapper":"BoardNavigationBar_navigationWrapper__oaltg","navigationBar":"BoardNavigationBar_navigationBar__3tqVU"};